type Listener = { key: string; method: any }

let keyDownListeners: Listener[] = []

export function addKeyDownListener(listener: Listener) {
  keyDownListeners.forEach((_listener) => {
    document.removeEventListener('keydown', _listener.method, { capture: false })
  })

  keyDownListeners = [listener, ...keyDownListeners.filter((_listener) => _listener.key != listener.key)]

  document.addEventListener('keydown', listener.method, { capture: false })
}

export function removeKeyDownListener(listener: Listener) {
  keyDownListeners.forEach((_listener) => {
    document.removeEventListener('keydown', _listener.method, { capture: false })
  })

  keyDownListeners = keyDownListeners.filter((_listener) => _listener.key != listener.key)

  if (keyDownListeners[0]) {
    document.addEventListener('keydown', keyDownListeners[0].method, { capture: false })
  }
}

let mouseUpListeners: Listener[] = []

export function addMouseUpListener(listener: Listener) {
  mouseUpListeners.forEach((_listener) => {
    document.removeEventListener('mouseup', _listener.method, { capture: false })
  })

  mouseUpListeners = [listener, ...mouseUpListeners.filter((_listener) => _listener.key != listener.key)]

  document.addEventListener('mouseup', listener.method, { capture: false })
}

export function removeMouseUpListener(listener: Listener) {
  mouseUpListeners.forEach((_listener) => {
    document.removeEventListener('mouseup', _listener.method, { capture: false })
  })

  mouseUpListeners = mouseUpListeners.filter((_listener) => _listener.key != listener.key)

  if (mouseUpListeners[0]) {
    document.addEventListener('mouseup', mouseUpListeners[0].method, { capture: false })
  }
}
